import { FormEvent, useState } from "react";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import {
  registrationInfoStore,
  useRegistration,
} from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { BackButton } from "../form/styles/back-button";
import { Checkbox } from "../form/styles/checkbox";
import { CtaButton } from "../form/styles/cta-button";
import { TermsCheckboxWrapper, TermsCompStyle } from "./terms.comp.styles";

export const TermsComp = (props: {
  setStep: (step: RegistrationSteps) => void;
}) => {
  const [liabilitySigned, setLiabilitySigned] = useState(
    registrationInfoStore?.liabilitySigned || false
  );
  const [covidGuidelinesSigned, seCovidGuidelinesSigned] = useState(
    registrationInfoStore?.covidGuidelinesSigned || false
  );
  const [photoReleaseAllSigned, setPhotoReleaseAllSigned] = useState(
    registrationInfoStore?.photoReleaseAllSigned || false
  );
  const [photoReleasePreApprovedSigned, setPhotoReleasePreApprovedSigned] =
    useState(registrationInfoStore?.photoReleasePreApprovedSigned || false);
  const [photoReleaseNoneSigned, setPhotoReleaseNoneSigned] = useState(
    registrationInfoStore?.photoReleaseNoneSigned || false
  );
  const [photoReleaseSigned, setPhotoReleaseSigned] = useState(
    registrationInfoStore?.photoReleaseSigned || false
  );
  const [codeSigned, setCodeSigned] = useState(
    registrationInfoStore?.codeSigned || false
  );
  const { registrationInfo, setRegistrationInfo, writeRegistrationInfo } = useRegistration();

  const canProceed = liabilitySigned && covidGuidelinesSigned && photoReleaseSigned && codeSigned && (photoReleaseAllSigned || photoReleasePreApprovedSigned || photoReleaseNoneSigned);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (canProceed) {
      writeRegistrationInfo();
      props.setStep(RegistrationSteps.Payment);
    }
  };

  const onBlur = () => {
    setRegistrationInfo({
      liabilitySigned,
      covidGuidelinesSigned,
      photoReleaseAllSigned,
      photoReleasePreApprovedSigned,
      photoReleaseNoneSigned,
      photoReleaseSigned,
      codeSigned,
    });
  };

  const onBack = (event: FormEvent) => {
    event.preventDefault();
    props.setStep(RegistrationSteps.StudentInfo);
  };

  return (
    <AppForm onSubmit={onSubmit}>
      <TermsCompStyle>
        <h3>Liability Waiver & COVID Requirements: *</h3>
        <p>
          In order to use the studio spaces and equipment at ColourInspired, the
          student must be enrolled in a current class, (S)he must also
          participate in the review and acceptance of studio use, safety and
          cleaning procedures as laid out by the instructor & ColourInspired
          studio manager, and obey all posted signage. If the student does not
          comply with the studio policies the student/parent acknowledges that
          an accident might occur.
        </p>
        <p>
          Completion of this form releases ColourInspired and its officers from
          any responsibility of accidents that may occur within the studio or
          while using ColourInspired equipment, including, but not limited to
          handling of the heat guns, glue guns, exacto knives, wood burner, use
          of epoxy, solvents, inks and paints. The student/parent also agrees
          that the student will not consume any art materials such as: glue,
          paint, glitter, epoxy, clay, chalk, etc. and will use art materials
          according to ColourInsipred guidelines only.
        </p>
        <p>
          The student/parent agrees that they have provided all the true and
          necessary information about any allergies or medications the student
          might have or needs to use and agrees for ColourInspired to provide
          first medical assistance in case a reaction might occur.
        </p>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={liabilitySigned}
            onChange={() => setLiabilitySigned(!liabilitySigned)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          I have read and understand the studio use & liability waiver
        </TermsCheckboxWrapper>

        <h3>COVID - 19 Guidelines: *</h3>
        <p>
          We are requiring all staff and studio users to comply with the rules
          of temperature checks, social distancing, wearing a mask indoors,
          disinfecting surfaces before and after use, and following all posted
          signage until COVID pandemic conditions change. These rules may change
          at any time, subject to Ontario COVID regulations.
        </p>
        <p>
          Failure to comply with these rules will result in suspension of studio
          access.
        </p>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={covidGuidelinesSigned}
            onChange={() => seCovidGuidelinesSigned(!covidGuidelinesSigned)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          I have read and understand the COVID requirements
        </TermsCheckboxWrapper>

        <h3>Photo Release: *</h3>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={photoReleaseAllSigned}
            onChange={() => setPhotoReleaseAllSigned(!photoReleaseAllSigned)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          Yes, you may use all photographs taken in connection to ColourInspired
          programs
        </TermsCheckboxWrapper>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={photoReleasePreApprovedSigned}
            onChange={() =>
              setPhotoReleasePreApprovedSigned(!photoReleasePreApprovedSigned)
            }
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          Yes, but you may only use certain pre-approved photographs
        </TermsCheckboxWrapper>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={photoReleaseNoneSigned}
            onChange={() => setPhotoReleaseNoneSigned(!photoReleaseNoneSigned)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          No you may not photograph me, my child or my work
        </TermsCheckboxWrapper>
        <p>
          I grant to ColourInspired, its representatives and employees the right
          to take photographs of me/my child and my/my child’s work in
          connection with the Education Program, Events and Studio Rental. I
          authorize ColourInspired, its assigns and transferees to copyright,
          use and publish the same in print and/or electronically. I agree that
          ColourInspired may use such photographs of me/my child with or without
          my name and for any lawful purpose, including such purposes as
          publicity, illustration, advertising, and Web content.
        </p>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={photoReleaseSigned}
            onChange={() => setPhotoReleaseSigned(!photoReleaseSigned)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          I have read and understand the above Photo Release
        </TermsCheckboxWrapper>

        <h3>Code of Conduct *</h3>
        <p>
          ColourInspired is committed to maintaining an environment of courtesy,
          safety, respect and proper conduct among all associated with the
          organization, including students, instructors, staff, interns,
          volunteers, studio renters, exhibiting artists and visitors. Some
          guidelines are set out below, with additional policies distributed in
          other documents for specific uses of our studios. Failure to adhere to
          the guidelines below, as well as in any additional document issued by
          ColourInspired, may lead to the individual’s membership, access
          volunteer, board or employment status being terminated or being asked
          to leave the premises and not return to ColourInspired studios, events
          or workshops. Any criminal conduct will be reported to the police and
          prosecuted.
        </p>
        <p>
          ColourInspired does not discriminate on the basis of race, color,
          national or ethnic origin, ancestry, age, religion or religious creed,
          disability, sex or gender, gender identity and/or expression, sexual
          orientation, military or veteran status, genetic information, or any
          other characteristic protected under applicable federal or local law.
          Nor does it tolerate behavior from others on ColourInspired’s premise
          that might violate such laws.
        </p>
        <p>
          ColourInspired has a zero-tolerance policy against threats or
          intimidation, stalking, bullying or verbal abuse, gestures of a
          violent or inappropriate nature, sexual harassment, physical assault,
          or any other behavior that creates a hostile environment.
        </p>
        <p>
          When using the studio, ColourInspired requires that individuals be
          kind and courteous to everyone, and follow the instructions issued by
          staff, teachers and studio assistants. Disruptive behavior that
          distracts from learning, art-making or the center’s day-to-day
          operations is not allowed.
        </p>
        <p>
          ColourInspired requires respect of the space by following all posted
          signage and verbal instruction. All safety rules and COVID
          disinfection rules MUST be followed, and it is recommended that studio
          users learn the potential hazards of all materials and processes used.
        </p>
        <p>
          ● All students should familiarize themselves with locations and
          instructions for emergency showers, eye washes, first aid kits, fire
          extinguishers and emergency exits, as well as the proper disposal of
          all art materials and proper use of disinfectants.
        </p>
        <p>
          ● ColouInspired is committed to making a continued effort to minimize
          contribution to pollution and waste, implementing sustainable
          practices whenever possible by both recycling and minimizing usage of
          petroleum-based products.
        </p>
        <TermsCheckboxWrapper>
          <Checkbox
            checked={codeSigned}
            onChange={() => setCodeSigned(!codeSigned)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          I have read and understand the Code of Conduct
        </TermsCheckboxWrapper>
      </TermsCompStyle>
      <div>
        <BackButton onClick={onBack}>Back</BackButton>
        <CtaButton disabled={!canProceed}>Next</CtaButton>
      </div>
    </AppForm>
  );
};
